import { User } from '@auth0/auth0-angular';
import { SupplierPortalMembership } from '../../models/user-profile.model';
import { CustomUserStyle } from '../../models/user-custom-config.model';

export interface UserInfo extends User {
  agAppId?: string | null;
  agOrgId?: string | null;
  agOrgName?: string | null;
  agOrgNameSmall?: string | null;
  agUserId?: string | null;
  org_id?: string | null;
  org_name?: string | null;
}

export interface AuthState {
  token: string | null;
  user: UserInfo | null;
  memberships: SupplierPortalMembership[] | null;
  selectedMemberId: number | null;
  tenantId: string | null;
  tenantLogo: string | null;
  theme: CustomUserStyle | null;
  isLoading: {
    memberships: boolean;
    token: boolean;
  };
  error: string | null;
}

export const initialAuthState: AuthState = {
  token: null,
  user: null,
  memberships: null,
  selectedMemberId: null,
  tenantId: null,
  tenantLogo: null,
  theme: null,
  isLoading: {
    memberships: false,
    token: false
  },
  error: null
};
